import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FAQs = () => {
    const [faqs, setFaqs] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
    const [formData, setFormData] = useState({ title: '', desc: '', id: null });

    // Fetch FAQs
    useEffect(() => {
        axios.get("https://palaceofriches.badskullgaming.com/api/get-faqs")
            .then(response => setFaqs(response.data.faqs))
            .catch(error => console.error("Error fetching FAQs:", error));
    }, []);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle modal open
    const handleOpenModal = (type, faq = null) => {
        setModalType(type);
        if (type === 'edit' && faq) {
            setFormData({ title: faq.title, desc: faq.desc, id: faq.id });
        } else {
            setFormData({ title: '', desc: '', id: null });
        }
        setShowModal(true);
    };

    // Handle modal close
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (modalType === 'add') {
            axios.post("https://palaceofriches.badskullgaming.com/api/store-faqs", {
                title: formData.title,
                desc: formData.desc
            })
                .then(() => {
                    toast.success("FAQ added successfully!");
                    // Refresh FAQs
                    axios.get("https://palaceofriches.badskullgaming.com/api/get-faqs")
                        .then(response => setFaqs(response.data.faqs));
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error storing FAQ:", error);
                    toast.error("Failed to add FAQ.");
                });
        } else if (modalType === 'edit') {
            axios.put(`https://palaceofriches.badskullgaming.com/api/update-faqs/${formData.id}`, {
                title: formData.title,
                desc: formData.desc
            })
                .then(() => {
                    toast.success("FAQ updated successfully!");
                    // Refresh FAQs
                    axios.get("https://palaceofriches.badskullgaming.com/api/get-faqs")
                        .then(response => setFaqs(response.data.faqs));
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error updating FAQ:", error);
                    toast.error("Failed to update FAQ.");
                });
        }
    };

    // Handle delete FAQ
    const handleDelete = (id) => {
        axios.delete(`https://palaceofriches.badskullgaming.com/api/deletefaqs/${id}`)
            .then(() => {
                setFaqs(faqs.filter(faq => faq.id !== id));
                toast.success("FAQ deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting FAQ:", error);
                toast.error("Failed to delete FAQ.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3">
                    <h2>FAQs</h2>
                    <Button onClick={() => handleOpenModal('add')} style={{ backgroundColor: '#FE0000', borderColor: '#FE0000', color: 'var(--bs-white)' }} className="mb-3 btn-danger">Add FAQ</Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {faqs.map((faq, index) => (
                            <tr key={faq.id}>
                                <td>{index + 1}</td>
                                <td>{faq.title}</td>
                                <td>{faq.desc}</td>
                                <td>
                                    <Button variant="danger" onClick={() => handleOpenModal('edit', faq)}>Edit</Button>{' '}
                                    <Button variant="danger" onClick={() => handleDelete(faq.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal for Add/Edit FAQ */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? 'Add FAQ' : 'Edit FAQ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDesc" className="mt-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter description"
                                name="desc"
                                value={formData.desc}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Button variant="danger" type="submit" className="mt-3">
                            {modalType === 'add' ? 'Add FAQ' : 'Update FAQ'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Toast container */}
            <ToastContainer />
        </>
    );
};

export default FAQs;
